import React, { useEffect, useState, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import Input from '../../../../components/Form/Input';
import Button from '../../../../components/Button';
import { nextAction } from '../../../../saga/actions/workflow';
import { getHTTPErrorMessage } from '../../../../utils/fetch';
import { getNextUrl } from '../url';
import { matchName } from '../../../../utils/masks';

const Step3 = (props) => {
  const { workflow } = props;
  // get functions to build form with useForm() hook
  const hookForm = useForm({ reValidateMode: 'onSubmit' });
  const { handleSubmit, setValue } = hookForm;

  const [isPrefilled, setIsPrefilled] = useState(false);

  const firstName = useMemo(() => get(workflow, 'data.data.firstName'), [workflow]);
  const lastName = useMemo(() => get(workflow, 'data.data.lastName'), [workflow]);
  const errorMsg = useMemo(() => getHTTPErrorMessage(workflow.error), [workflow]);

  // set initial values
  useEffect(() => {
    setValue('firstName', firstName);
    setValue('lastName', lastName);
    if (firstName || lastName) {
      setIsPrefilled(true);
    }
  }, [firstName, lastName, setValue]);

  // handle functions
  const onSubmit = (data) => {
    props.nextAction({
      url: getNextUrl(),
      method: 'PUT',
      data: {
        firstName: data.firstName,
        lastName: data.lastName,
      },
    });
    return false;
  };
  const validateName = (name) => {
    if (!name) {
      return 'Name is required';
    } if (!matchName(name)) {
      return `${name} is not a valid name.`;
    }
    return null;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="text-center md:text-left font-bold text-[26px] leading-[26px] md:text-[32px] md:leading-[38px] text-[#263952]">
        We need some
        {' '}
        <br />
        {' '}
        personal details from you.
      </div>
      <div className="text-center md:text-left font-normal text-[15px] leading-[20px] text-[#263952] mt-[8px] ">
        This won’t affect your credit score
        {' '}
        <sup>1</sup>
      </div>
      { isPrefilled
        ? (
          <>
            <div className="text-center md:text-left font-medium text-[18px] leading-[32px] text-black mt-[53px]">
              Please confirm your first and last name.
            </div>
            <div className="text-center md:text-left font-normal text-[12px] leading-[20px] text-[#9B9B9B] mt-[5px]">
              You can edit this information as needed.
            </div>
          </>
        )
        : (
          <div className="text-center md:text-left font-medium text-[18px] leading-[32px] text-black mt-[53px]">
            What’s your first and last name?
          </div>
        )}
      <Input
        autoFocus
        name="firstName"
        label="First Name"
        className="w-full md:w-11/12 mt-[20px]"
        isMasked={false}
        hookForm={hookForm}
        registerOptions={{
          required: 'First Name is required',
          validate: validateName,
          onBlur: (e) => {
            const value = e.target.value || '';
            e.target.value = value.replace(/\w+/g, (w) => w[0].toUpperCase() + w.slice(1).toLowerCase());
          },
        }}
      />
      <Input
        name="lastName"
        label="Last Name"
        className="w-full md:w-11/12"
        isMasked={false}
        hookForm={hookForm}
        registerOptions={{
          required: 'Last Name is required',
          validate: validateName,
          onBlur: (e) => {
            const value = e.target.value || '';
            e.target.value = value.replace(/\w+/g, (w) => w[0].toUpperCase() + w.slice(1).toLowerCase());
          },
        }}
      />
      <Button isLoading={workflow.isLoading} type="submit" className="w-full md:w-[240px]">Continue</Button>
      {errorMsg && <div className="mt-3 mb-3 text-[#d71f28] text-xs">{errorMsg}</div>}
    </form>
  );
};

Step3.propTypes = {
  workflow: PropTypes.object.isRequired,
  nextAction: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => ({
      workflow: state.workflow,
    }),
    {
      nextAction,
    }
  )
)(Step3);
